document.addEventListener('DOMContentLoaded', () => {

  /* =========================================================
     MOBILE DRAWER
     ========================================================= */

  const drawer = document.getElementById('EmpDrawer');
  const openBtn = document.querySelector('.emp-header__toggle');
  const closeBtn = document.querySelector('.emp-drawer__close');
  const overlay = document.querySelector('.emp-drawer__overlay');
  const body = document.body;

  if (drawer && openBtn) {

    const openDrawer = () => {
      drawer.classList.add('active');
      drawer.setAttribute('aria-hidden', 'false');
      openBtn.setAttribute('aria-expanded', 'true');
      body.classList.add('drawer-open');
    };

    const closeDrawer = () => {
      drawer.classList.remove('active');
      drawer.setAttribute('aria-hidden', 'true');
      openBtn.setAttribute('aria-expanded', 'false');
      body.classList.remove('drawer-open');
    };

    openBtn.addEventListener('click', openDrawer);
    closeBtn?.addEventListener('click', closeDrawer);
    overlay?.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeDrawer();
      }
    });

    drawer.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', closeDrawer);
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth >= 990) {
        closeDrawer();
      }
    });
  }


  /* =========================================================
     HEADER
     ========================================================= */

  const header = document.querySelector('.emp-header');

  if (!header) return;


  /* =========================================================
     PAGE DETECTION
     ========================================================= */

  const hero = document.querySelector('.hero-slider');
  const collectionHero = document.querySelector('.collection-hero');

  const isHomepage =
    document.body.classList.contains('template-index');

  const hasHero =
    isHomepage ||
    !!hero ||
    !!collectionHero;


  /* =========================================================
     HEADER UPDATE
     ========================================================= */

  function updateHeader() {

    if (hasHero) {

      header.classList.add('hero-header');

      if (window.scrollY <= 60) {

        header.classList.remove('scrolled');
        header.classList.add('transparent-header');

      } else {

        header.classList.add('scrolled');
        header.classList.remove('transparent-header');

      }

    } else {

      /*
       NORMAL PAGES
       */

      header.classList.remove('hero-header');
      header.classList.remove('transparent-header');
      header.classList.remove('scrolled');

    }
  }


  /* =========================================================
     INITIAL STATE
     ========================================================= */

  updateHeader();


  /* =========================================================
     SCROLL
     ========================================================= */

  window.addEventListener(
    'scroll',
    updateHeader,
    { passive: true }
  );


  /* =========================================================
     RESIZE
     ========================================================= */

  window.addEventListener(
    'resize',
    updateHeader
  );


  /* =========================================================
     SHOPIFY THEME EDITOR
     ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    updateHeader
  );

  document.addEventListener(
    'shopify:section:reorder',
    updateHeader
  );

  document.addEventListener(
    'shopify:section:select',
    updateHeader
  );

  document.addEventListener(
    'shopify:section:deselect',
    updateHeader
  );

});